import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, pipe } from "rxjs";
import { map } from "rxjs/operators";
import {
    Bodytype,
    Characteristic,
    EurocodeRecord,
    Glassposition,
    Glasstint,
    Glasstype,
    Model,
} from "src/app/argic/domain/eurocode";
import { LoginService } from "src/app/login/login.service";
import { AcType } from "src/app/models/ac-type";
import { Manufacturer } from "src/app/models/manufacturer";
import { environment } from "src/environments/environment";
import { EurocodeChangeRequest } from "../domain/eurocodechangerequest";
import { EurocodeHistoric } from "../domain/eurocodehistoric";

@Injectable({
    providedIn: "root",
})
export class FilterdataService {
    constructor(private http: HttpClient, private loginService: LoginService) { }

    getHistorics(eurocode: string): Observable<EurocodeHistoric[]> {
        return this.http
            .get<EurocodeHistoric[]>(
                environment.apiWizardUrl +
                "EurocodeHistoric/QueryEurocode?eurocode=" +
                eurocode,
                {
                    withCredentials: true,
                }
            )
            .pipe(
                map((x) => {
                    let data = x;
                    if(data){
                        data.forEach((x) => {
                            x.ParsedChangeDate = new Date(
                                parseInt(
                                    x.ChangeDate.replace("/Date(", "").replace(
                                        ")/",
                                        ""
                                    ),
                                    10
                                )
                            );
                            let langid = this.loginService.userprofile.languageId;
                            let langfield;
                            switch (langid) {
                                case 1:
                                    langfield = "Descr_EN";
                                    break;
                                case 2:
                                    langfield = "Descr_DE";
                                    break;
                                case 3:
                                    langfield = "Descr_FR";
                                    break;
                                case 4:
                                    langfield = "Descr_IT";
                                    break;
                                case 5:
                                    langfield = "Descr_ES";
                                    break;
                                case 6:
                                    langfield = "Descr_NL";
                                    break;
                            }
                            x.Description = x[langfield];
                            if (x.Description == null || x.Description.length == 0)
                                x.Description = x.Descr_EN;
                        });
                    }
                    return data;
                })
            );
    }

    getEurocodeHis(eurocode: string): Observable<EurocodeChangeRequest[]> {
        return this.http
            .get<EurocodeChangeRequest[]>(
                environment.apiWizardUrl +
                "EurocodeHistoric/ChangeRequests?eurocode=" +
                eurocode,
                {
                    withCredentials: true,
                }
            )
            .pipe(
                map((x) => {
                    let data = x;
                    if(data){
                        data.forEach((x) => {

                            x.OEM = x.OEM;
                            x.SAMEAS = x.SAMEAS
                            x.Fulldescription = x.Des ?? "";
                            if (x.Char)
                                x.Fulldescription += "\n" + (x.Char ?? "");
                            if (x.Modif)
                                x.Fulldescription += "\n" + (x.Modif ?? "");
                            if (x.Info)
                                x.Fulldescription += "\n" + (x.Info ?? "");
        
                            x.Fulldescription = x.Fulldescription.toUpperCase().trim();


                            if (
                                x.HistoricDate != null &&
                                x.HistoricDate.toLowerCase() != "null"
                            )
                                x.ParsedHistoricDate = new Date(
                                    parseInt(
                                        x.HistoricDate.replace(
                                            "/Date(",
                                            ""
                                        ).replace(")/", ""),
                                        10
                                    )
                                );
                        });
                    }
                    return data;
                })
            );
    }

    getFiles(eurocode: string): Observable<EurocodeHistoric[]> {
        return this.http.get<EurocodeHistoric[]>(
            environment.apiWizardUrl + "Upload/Files/" + eurocode,
            {
                withCredentials: true,
            }
        );
    }

    getOne(eurocode: string,searchdata: any): Observable<EurocodeRecord> {

        const params = new HttpParams()
        .set('eurocode', eurocode)
        .set('searchdata', JSON.stringify(searchdata));
        return this.http
        .get<EurocodeRecord>(`${environment.apiWizardUrl}EurocodeRecords/getOne`, { params, withCredentials: true })
            .pipe(
                map((data) => {
                    data.oem = data.oem;
                    data.sameAs = data.sameAs
                    data.fulldescription = data.des ?? "";
                    if (data.char)
                        data.fulldescription += "\n" + (data.char ?? "");
                    if (data.modif)
                        data.fulldescription += "\n" + (data.modif ?? "");
                    if (data.info)
                        data.fulldescription += "\n" + (data.info ?? "");

                    data.fulldescription = data.fulldescription.toUpperCase().trim();

                    return data;
                })
            );
    }

    getAll(searchdata: any): Observable<EurocodeRecord[]> {
        return this.http
            .get<EurocodeRecord[]>(
                environment.apiWizardUrl +
                "EurocodeRecords/q?searchdata=" +
                JSON.stringify(searchdata),
                { withCredentials: true }
            )
            .pipe(
                map((l) => {
                    l.forEach((data) => {
                        data.oem = data.oem;
                        data.sameAs = data.sameAs;

                        data.fulldescription = data.des ?? "";
                        if (data.char ?? false)
                            data.fulldescription += "\n" + (data.char ?? "");
                        if (data.modif ?? false)
                            data.fulldescription += "\n" + (data.modif ?? "");
                        if (data.info ?? false)
                            data.fulldescription += "\n" + (data.info ?? "");

                        data.fulldescription = data.fulldescription.toUpperCase().trim();
                    });
                    return l;
                })
            );
    }

    getManufacturer(id: number): Observable<Manufacturer> {
        return this.http.get<Manufacturer>(
            environment.apiWizardUrl + "ManufacturersMatrixSearch/getOne?id=" + id,
            { withCredentials: true }
        );
    }
    getManufacturers(): Observable<Manufacturer[]> {
        return this.http.get<Manufacturer[]>(
            environment.apiWizardUrl + "ManufacturersMatrixSearch",
            { withCredentials: true }
        );
    }

    getModels(): Observable<Model[]> {
        return this.http.get<Model[]>(environment.apiWizardUrl + "ModelsMatrixSearch",
            { withCredentials: true }
        );
    }

    getModelsQuery(searchdata: any): Observable<Model[]> {
        return this.http.get<Model[]>(
            environment.apiWizardUrl + "ModelsMatrixSearch/q?searchdata=" + JSON.stringify(searchdata),
            { withCredentials: true }
        );
    }

    getAcTypes(): Observable<AcType[]> {
        return this.http.get<AcType[]>(environment.apiWizardUrl + "Actypes",
            { withCredentials: true }
        );
    }

    getGlasstypes(): Observable<Glasstype[]> {
        return this.http.get<Glasstype[]>(
            environment.apiWizardUrl + "Glasstypes/",
            { withCredentials: true }
        );
    }

    getCharacteristics(): Observable<Characteristic[]> {
        return this.http
            .get<Characteristic[]>(environment.apiWizardUrl + "Characteristics",
                { withCredentials: true }
            )
            .pipe(
                map((data) =>
                    data.sort((a, b) => {
                        if (a.charID < b.charID) {
                            return -1;
                        }
                        if (a.charID > b.charID) {
                            return 1;
                        }
                        return 0;
                    })
                )
            );
    }

    getGlasstints(): Observable<Glasstint[]> {
        return this.http.get<Glasstint[]>(
            environment.apiWizardUrl + "GlassTint",
            { withCredentials: true }
        );
    }

    getGlasstoptints(): Observable<Glasstint[]> {
        return this.http.get<Glasstint[]>(
            environment.apiWizardUrl + "GlassTint",
            { withCredentials: true }
        );
    }

    getBodytypes(): Observable<Bodytype[]> {
        return this.http.get<Bodytype[]>(environment.apiWizardUrl + "BodyType",
            { withCredentials: true }
        );
    }

    getGlasspositions(): Observable<Glassposition[]> {
        return this.http.get<Glassposition[]>(
            environment.apiWizardUrl + "GlassPosition",
            { withCredentials: true }
        );
    }
}
